// == Import : npm
import { connect } from 'react-redux';

// == Import : local
import News from '../../screen/News';

// Action Creators
import { getAll } from '../../store/reducer';

const mapStateToProps = (state, ownProps) => ({
  datas: state.news,
  waitingRequest: state.waitingRequest,
  connected: state.connected,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  getAll: (type, password) => {
    dispatch(getAll(type, ownProps.match.params.page, ownProps.history));
  },
});

// Container
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(News);